import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { homepageApi } from '../services/api'

const HomepageContext = createContext({
  sections: {},
  loaded: false,
  loading: true,
})

export function HomepageProvider({ children }) {
  const [sections, setSections] = useState({})
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    homepageApi
      .getAll()
      .then(({ data }) => {
        const items = data.data || data || []
        const mapped = {}
        if (Array.isArray(items)) {
          items.forEach((section) => {
            if (section?.key) mapped[section.key] = section
          })
        }
        setSections(mapped)
      })
      .catch(() => setSections({}))
      .finally(() => {
        setLoaded(true)
        setLoading(false)
      })
  }, [])

  const value = useMemo(
    () => ({ sections, loaded, loading }),
    [sections, loaded, loading],
  )

  return <HomepageContext.Provider value={value}>{children}</HomepageContext.Provider>
}

export function useHomepage() {
  const context = useContext(HomepageContext)
  if (!context) {
    throw new Error('useHomepage must be used within HomepageProvider')
  }
  return context
}
